import { useState, useEffect, useCallback } from "react";

const KEY = "riders_active_platform";
const EVENT = "riders-platform-change";
export const UNIFIED = "__all__";
export const DEFAULT_PLATFORM = "هنجرستيشن";

// Brand identity per known platform (colors used across the switcher + KPI accents).
export const PLATFORM_STYLES = {
  "هنجرستيشن": { color: "#F70", bg: "#FFF3E9", ring: "#FFD5B0", text: "#B44900", emoji: "🍔", logo: "/platforms/hungerstation.png" },
  "نينجا": { color: "#111827", bg: "#EAF6F7", ring: "#BCE3E8", text: "#0E7490", emoji: "🥷", logo: "/platforms/ninja.png" },
  "كيتا": { color: "#F5C400", bg: "#FFF9E0", ring: "#FFE98A", text: "#8A6D00", emoji: "🛵", logo: "/platforms/keeta.png" },
};
export const KEETA_PLATFORMS = ["كيتا طلبات", "كيتا شرائح"];
const normAr = (p) => String(p || "").replace(/[\u200b-\u200f\ufeffـ]/g, "").replace(/ک/g, "ك").replace(/[یى]/g, "ي").trim();
export const isKeeta = (p) => normAr(p).startsWith("كيتا") || /^keeta/i.test(normAr(p));
const FALLBACK_STYLE = { color: "#2563EB", bg: "#EFF6FF", ring: "#BFDBFE", text: "#1D4ED8", emoji: "📦", logo: null };

// Org-specific custom styles (color/logo) for platforms, hydrated from /riders-config.
let _orgStyles = {};
export const setOrgStyles = (styles) => { _orgStyles = styles || {}; };
const _API = process.env.REACT_APP_BACKEND_URL;

export const platformStyle = (name) => {
  const base = PLATFORM_STYLES[name] || (isKeeta(name) ? PLATFORM_STYLES["كيتا"] : FALLBACK_STYLE);
  const custom = _orgStyles[name] || (isKeeta(name) ? _orgStyles["كيتا"] : null);
  if (!custom) return base;
  const color = custom.color || base.color;
  const hasColor = Boolean(custom.color);
  const logo = custom.logo_id ? `${_API}/api/files/${custom.logo_id}` : base.logo;
  return {
    color,
    bg: hasColor ? `${color}1A` : base.bg,
    ring: hasColor ? `${color}66` : base.ring,
    text: hasColor ? color : base.text,
    emoji: base.emoji, logo,
  };
};

export const getPlatform = () => {
  try { const v = localStorage.getItem(KEY) || UNIFIED; return v === "كيتا" ? KEETA_PLATFORMS[0] : v; } catch { return UNIFIED; }
};

export const setPlatform = (p) => {
  try { localStorage.setItem(KEY, p); } catch { /* ignore */ }
  window.dispatchEvent(new CustomEvent(EVENT, { detail: p }));
};

// Shared reactive hook: every panel using it stays in sync with the active platform.
export const usePlatform = () => {
  const [platform, setLocal] = useState(getPlatform());
  useEffect(() => {
    const onChange = (e) => setLocal(e.detail || getPlatform());
    window.addEventListener(EVENT, onChange);
    return () => window.removeEventListener(EVENT, onChange);
  }, []);
  const change = useCallback((p) => setPlatform(p), []);
  return [platform, change];
};
